import { render, staticRenderFns } from "./NombreNcParProduit.vue?vue&type=template&id=0e3648bf&scoped=true"
import script from "./NombreNcParProduit.vue?vue&type=script&lang=js"
export * from "./NombreNcParProduit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3648bf",
  null
  
)

export default component.exports